import { useEffect, useState } from "react";
import {
  Button,
 Container,
  
  } from "react-bootstrap";
import { ErrorPageDetail, ErrorPageSection, ErrorPageText } from "./errorStyle";
import { Link, useNavigate } from "react-router-dom";


const NotFound = () =>
{
  const navigate = useNavigate();
return (
  <ErrorPageSection>
  <Container className="cont-w">

  <ErrorPageDetail>
      <h1>404</h1>
      <ErrorPageText>Ooops!!! The page you are looking for is not found</ErrorPageText>
      <div className="primaryBtnWrap">
        <Button onClick={() => navigate("/dashboard")}>Back to home</Button>
      </div>
  </ErrorPageDetail>
      

  </Container>
</ErrorPageSection>
   );
}

export default NotFound